import { render, staticRenderFns } from "./InlineCustomerWidget.vue?vue&type=template&id=153e8a49&scoped=true&"
import script from "./InlineCustomerWidget.vue?vue&type=script&lang=ts&"
export * from "./InlineCustomerWidget.vue?vue&type=script&lang=ts&"
import style0 from "./InlineCustomerWidget.vue?vue&type=style&index=0&id=153e8a49&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153e8a49",
  null
  
)

export default component.exports